import React from 'react'
import {
    Dialog,
    DialogContent,
    DialogTitle,
} from '@mui/material'
import idDirectory from '../StandardModal/idAttributes'
import './AISummary.scss'

export interface AISummaryModalProps {
    openModal: boolean
    onModalClose: () => void
    modalHeaderTitle: string
    modalSubHeaderTitle: string
    children: React.ReactNode
    testId: string
    maxModalWidth?: 'lg' | 'md' | 'sm' | 'xl' | 'xs' | false
    enableErrorTitleStyling?: boolean
    enablePrimaryActionBtn?: boolean
    primaryBtnText?: string
    handlePrimaryActionBtn?: () => void
    inactivatePrimaryActionBtn?: boolean
    isLoadingPrimaryActionBtn?: boolean
    enableSecondaryActionBtn?: boolean
    secondaryBtnText?: string
    handleSecondaryActionBtn?: () => void
    inactivateSecondaryActionBtn?: boolean
    isLoadingSecondaryActionBtn?: boolean
    disableBackdropClick?: boolean
    showClientThemeTopBorder?: boolean
    disableTitleBackgroundColor?: boolean
    dialogActionsAlignment?: 'left' | 'center' | 'right'
    className?: string
}

const AISummaryModal = ({
    openModal,
    onModalClose,
    modalHeaderTitle,
    modalSubHeaderTitle,
    children,
    testId,
    maxModalWidth = 'md',
    disableBackdropClick = false,
    className = '',
}: AISummaryModalProps): React.ReactElement => {    
    return (
        <Dialog
            fullWidth
            open={openModal}
            onClose={disableBackdropClick ? () => undefined : onModalClose}
            className={className}
            maxWidth={maxModalWidth}
            id={`${idDirectory.divRoot}-${testId}`}
        >
            <DialogTitle
                className="ai-summary-modal-dialogTitle"
                id={`${idDirectory.divTitle}-${testId}`}
            >
                <div className="ai-summary-modal-header">
                    <div className="ai-summary-modal-icon">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            className="ai-summary-modal-icon-svg"
                        >
                            <path
                                fillRule="evenodd"
                                d="M9 4.5a.75.75 0 0 1 .721.544l.813 2.846a3.75 3.75 0 0 0 2.576 2.576l2.846.813a.75.75 0 0 1 0 1.442l-2.846.813a3.75 3.75 0 0 0-2.576 2.576l-.813 2.846a.75.75 0 0 1-1.442 0l-.813-2.846a3.75 3.75 0 0 0-2.576-2.576l-2.846-.813a.75.75 0 0 1 0-1.442l2.846-.813A3.75 3.75 0 0 0 7.466 7.89l.813-2.846A.75.75 0 0 1 9 4.5ZM18 1.5a.75.75 0 0 1 .728.568l.258 1.036c.236.94.97 1.674 1.91 1.91l1.036.258a.75.75 0 0 1 0 1.456l-1.036.258c-.94.236-1.674.97-1.91 1.91l-.258 1.036a.75.75 0 0 1-1.456 0l-.258-1.036a2.625 2.625 0 0 0-1.91-1.91l-1.036-.258a.75.75 0 0 1 0-1.456l1.036-.258a2.625 2.625 0 0 0 1.91-1.91l.258-1.036A.75.75 0 0 1 18 1.5ZM16.5 15a.75.75 0 0 1 .712.513l.394 1.183c.15.447.5.799.948.948l1.183.395a.75.75 0 0 1 0 1.422l-1.183.395c-.447.15-.799.5-.948.948l-.395 1.183a.75.75 0 0 1-1.422 0l-.395-1.183a1.5 1.5 0 0 0-.948-.948l-1.183-.395a.75.75 0 0 1 0-1.422l1.183-.395c.447-.15.799-.5.948-.948l.395-1.183A.75.75 0 0 1 16.5 15Z"
                                clipRule="evenodd"
                            />
                        </svg>

                        {/* <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke={clientTheme.primary}
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
                            />
                        </svg> */}
                    </div>
                    <div className="ai-summary-modal-header-content">
                        <div className="ai-summary-modal-title">
                            {modalHeaderTitle}
                        </div>
                        <div className="ai-summary-modal-subtitle">
                            {modalSubHeaderTitle}
                        </div>
                    </div>
                </div>
                <button
                    className="ai-summary-modal-close"
                    onClick={onModalClose}
                    type="button"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M6 18 18 6M6 6l12 12"
                        />
                    </svg>
                </button>
            </DialogTitle>
            <DialogContent
                className="ai-summary-modal-content"
                id={`${idDirectory.divContent}-${testId}`}
            >
                {children}
            </DialogContent>
            {/* <DialogActions
                className="emp-standardModal-dialogActions"
                id={`${idDirectory.divActions}-${testId}`}
                style={{ justifyContent: 'flex-end' }}
            >
                <Button
                    variant="contained"
                    color="primary"
                    onClick={onModalClose}
                >
                    Close
                </Button>
            </DialogActions> */}
        </Dialog>
    )
}

export default AISummaryModal 